import { normalizeProductNameKey } from "./productDocumentDto";

export const WORKFLOW_PRODUCT_REFERENCE_ENTITY_TYPE = "workflowProductReference";

/**
 * Product-to-workflow lookup row in `projectstore-metadata`.
 *
 * Canonical rows live at:
 *   pk = "{accountId}:workflowByProduct:{productNameKey}"
 *   sk = "!workflow:{workflowId}"
 *
 * The authoritative workflow remains `workflow.yaml`; this row is an
 * idempotent reference projection refreshed after workflow validation.
 */
export interface WorkflowProductReferenceDto {
  readonly entityType: typeof WORKFLOW_PRODUCT_REFERENCE_ENTITY_TYPE;
  readonly productName: string;
  readonly productNameKey: string;
  readonly workflowId: string;
  readonly workflowName?: string;
  readonly workflowVersion?: string;
  readonly firstReferencedAt: string;
  readonly lastValidatedAt: string;
  readonly validatedBy?: string;
  readonly [extra: string]: unknown;
}

export interface WorkflowProductReferenceInput {
  readonly productName: string;
  readonly productNameKey: string;
  readonly workflowId: string;
  readonly workflowName?: string;
  readonly workflowVersion?: string;
  readonly validatedBy?: string;
}

export function workflowByProductPk(accountId: string, productName: string): string {
  return `${accountId}:workflowByProduct:${normalizeProductNameKey(productName)}`;
}

export function workflowProductReferenceSk(workflowId: string): string {
  return `!workflow:${workflowId}`;
}

export function workflowIdFromProductReferenceSk(sk: string | null | undefined): string {
  const value = sk?.trim() ?? "";
  return value.startsWith("!workflow:") ? value.slice("!workflow:".length) : "";
}
